import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

interface ThemeToggleProps {
  className?: string;
  showLabel?: boolean;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ className = '', showLabel = false }) => {
  const { isNightMode, toggleTheme } = useTheme();
  const label = isNightMode ? 'الوضع النهاري' : 'الوضع الليلي';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isNightMode ? 'التبديل إلى الوضع النهاري' : 'التبديل إلى الوضع الليلي'}
      aria-pressed={isNightMode}
      title={label}
      className={
        showLabel
          ? `inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-xl px-4 py-3 text-sm font-semibold transition-colors ${className}`
          : `inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border transition-all ${className}`
      }
    >
      <span className="relative flex h-5 w-5 items-center justify-center">
        <Sun
          className={`absolute h-5 w-5 transition-all duration-300 ease-out ${
            isNightMode ? 'scale-100 rotate-0 opacity-100' : 'scale-0 rotate-90 opacity-0'
          }`}
          aria-hidden
        />
        <Moon
          className={`absolute h-5 w-5 transition-all duration-300 ease-out ${
            isNightMode ? 'scale-0 -rotate-90 opacity-0' : 'scale-100 rotate-0 opacity-100'
          }`}
          aria-hidden
        />
      </span>
      {showLabel && <span>{label}</span>}
    </button>
  );
};

export default ThemeToggle;
